import { lockBody, unlockBody } from '../modules/lock-body';

export class CurtainMenu {
    constructor(public bodyElement: any) {
        let curtainTrigger = document.getElementById('curtainMenutrigger');
        let curtainTriggerText = curtainTrigger.querySelector('.link-text');
        let curtainMenu = document.getElementById('curtainMenu');
        let curtainMenuInner = <HTMLElement>document.querySelector('.curtain-menu-inner');
        let sideHeaderHeight = document.querySelector('#siteHeader').scrollHeight;
        let menuSubnavTriggers = [].slice.call(document.querySelectorAll('.nav-sub-trigger'));

        if (curtainTrigger) {
            curtainTrigger.addEventListener('click', e => {
                e.preventDefault();

                if (curtainMenu.classList.contains('open')) {
                    curtainMenu.classList.remove('open');
                    curtainTrigger.classList.remove('open');
                    this.bodyElement.classList.remove('nav-open');
                    window.removeEventListener('resize', isAlertOpenResize);
                    unlockBody();
                    closeAllSubs();
                    curtainTriggerText.innerHTML = 'Menu';
                } else {
                    showFirstAccordion();
                    curtainMenu.classList.add('open');
                    curtainTrigger.classList.add('open');
                    this.bodyElement.classList.add('nav-open');
                    isAlertOpen();
                    window.addEventListener('resize', isAlertOpenResize);
                    lockBody();
                    curtainTriggerText.innerHTML = 'Close';
                }
            });
        }

        function closeAllSubs() {
            let allOpenSubs = [].slice.call(document.querySelectorAll('.nav-main-list-sub.open'));

            for (var i = 0, l = allOpenSubs.length; i < l; i++) {
                allOpenSubs[i].setAttribute('aria-hidden', 'true');
                allOpenSubs[i].classList.remove('open');
            }
        }

        function showFirstAccordion() {
            if (menuSubnavTriggers && window.matchMedia('(min-width: 768px)').matches) {
                let firstMenu = menuSubnavTriggers[0].getAttribute('data-trigger-id');
                handleSubMenu(firstMenu);
            }
        }

        function isAlertOpen() {
            if (document.querySelector('.site-wide-alert-show')) {
                sideHeaderHeight = document.querySelector('#siteHeader').scrollHeight;

                curtainMenuInner.style.paddingTop = sideHeaderHeight + 'px';
            }
        }

        function isAlertOpenResize() {         
            if (document.querySelector('#siteHeader').scrollHeight != sideHeaderHeight) {
                sideHeaderHeight = document.querySelector('#siteHeader').scrollHeight;

                curtainMenuInner.style.paddingTop = sideHeaderHeight + 'px';
            }                    
        }

        function handleCalloutsDisplay(calloutsData) {
            let calloutLength = calloutsData.callouts.length;

            if (calloutLength > 0) {
                let calloutMarkup = '';

                for (var i = 0; i < calloutLength; i++) {
                    let callout = calloutsData.callouts[i];

                    calloutMarkup += '<div class="item nav-callouts-item">';
                    calloutMarkup += '  <a href="' + callout.linkUrl + '" class="item-image-wrapper item-media item-effect">';
                    calloutMarkup +=
                        '    <div class="item-image" style="background-image: url(' +
                        callout.image +
                        ')" aria-hidden="true" role="presentation"></div>';
                    calloutMarkup += '  </a>';
                    calloutMarkup += '  <div class="item-content">';
                    calloutMarkup += '    <h3 class="item-title">' + callout.title + '</h3>';
                    calloutMarkup += '    <p class="item-date nav-callouts-item-date">' + callout.date + '</p>';
                    calloutMarkup += '    <a class="action-link" href="' + callout.linkUrl + '">' + callout.linkTitle + '</a>';
                    calloutMarkup += '  </div>';
                    calloutMarkup += '</div>';
                }

                document.querySelector('.nav-callouts-body').innerHTML = calloutMarkup;
            }
        }

        function handleSubMenu(triggerId) {
            let subnavID = triggerId;
            let subnavToOpen = document.getElementById(subnavID);

            if (subnavToOpen.getAttribute('aria-hidden') === 'true') {
                closeAllSubs();
                subnavToOpen.setAttribute('aria-hidden', 'false');
                subnavToOpen.classList.add('open');

                let calloutsData = JSON.parse(subnavToOpen.dataset.callouts);
                handleCalloutsDisplay(calloutsData);
            } else {
                subnavToOpen.setAttribute('aria-hidden', 'true');
                subnavToOpen.classList.remove('open');
            }
        }

        if (menuSubnavTriggers) {
            for (var i = 0, l = menuSubnavTriggers.length; i < l; i++) {
                menuSubnavTriggers[i].addEventListener('click', function(e) {
                    e.preventDefault();
                    handleSubMenu(this.getAttribute('data-trigger-id'));
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/curtain-menu.ts